import styled, { keyframes } from "styled-components";

const situate = `
display:flex;
justify-content:center;
align-items:center;
`;
export const slideRight = keyframes`
0%{transform:translateX(-100%);}
100%{transform:translateX(0%);}
`,
  slideLeft = keyframes`
0%{transform:translateX(100%);}
100%{transform:translateX(0%);}
`,
  StyledAbout = styled.section`
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1vw 0vw;
    @media only screen and (min-width: 600px) {
      align-items: space-between;
      flex-direction: row;
      padding: 2rem 0rem;
      justify-content: center;
    } ;
  `,
  StandIn = styled.div`
    opacity:0;
  `,
  Left = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #304057;
    animation: ${slideRight} 0.35s linear 0s 1;
    @media only screen and (min-width: 600px) {
      justify-content: flex-end;
      background-color: #ffffff;
    } ;
  `,
  Right = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    animation: ${slideLeft} 0.35s linear 0s 1;
    @media only screen and (min-width: 600px) {
      padding-left: 3vw;
      align-items: flex-start;
    }
  `,
  BoldText = styled.h1`
    font-size: 18px;
    font-weight: 600;
    padding: 1vw 0vw;
    color: #083f88;
    @media only screen and (min-width: 600px) {
      font-size: 20px;
    }
    @media only screen and (min-width: 725px) {
      font-size: 24px;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 2.4vw;
    }
  `,
  
  MobileIconText = styled.h1`
    font-size: 16px;
    font-weight: 600;
    padding: 1vw 0vw;
    text-align: center;
    color: #083f88;
    @media only screen and (min-width: 600px) {
      font-size: 20px;
    }
     @media only screen and (min-width: 725px) {
      font-size: 24px;
     }
     @media only screen and (min-width: 1000px) {
      font-size: 2.4vw;
    }
  `
  ,
    
  MobileText = styled.h6`
  font-size: 13px;
  line-height: 2;
  padding: 1vw 0vw;
  color: #444444;
  text-align: left;
  font-weight: 400;
  @media only screen and (max-width: 599px) {
    text-align: center;  
  }
  @media only screen and (min-width: 600px) {
    text-align: left;
    font-size: 2vw;

    line-height: 1;
    padding: 1vw 0vw;
  }
  @media only screen and (min-width: 800px) {
    font-size: 1.8vw;
    line-height: 1.25;
  }
  @media only screen and (min-width: 1000px) {
    font-size: 1.5vw;
    padding: 1vw 0vw;
    line-height: 1.5;
  }
  `
    ,
  SubText = styled.h6`
    font-size: 15px;
    line-height: 2;
    padding: 1vw 0vw;
    color: #444444;
    text-align: left;
    font-weight: 400;
    @media only screen and (max-width: 599px) {
      text-align: center;  
    }
    @media only screen and (min-width: 600px) {
      text-align: left;
      font-size: 2vw;

      line-height: 1;
      padding: 1vw 0vw;
    }
    @media only screen and (min-width: 800px) {
      font-size: 1.8vw;
      line-height: 1.25;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 1.5vw;
      padding: 1vw 0vw;
      line-height: 1.5;
    } ;
  `,
  SubTextBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 90%;
    padding: 0vw 0vw 1vw 0vw;
  `,
  PhotoBox = styled.div`
    ${situate}
    flex-direction:column;
    border-radius: 10px;
    padding: 1vw;
    background: #304057;
  `,
  PhotoRow = styled.div`
    ${situate}
    width:100%;
    border-radius: 10px;
  `,
  Photo = styled.img`
    border-radius: 10px;
    height: 30vw;
    margin: 0.5vw;
    @media only screen and (min-width: 600px) {
      height: 15.5vw;
      max-height: 7rem;
    }
    @media only screen and (min-width: 1000px) {
      max-height: 12.5rem;
    } ;
  `,
  TextBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: calc(100% - 3vw);
    max-width: 50rem;
    height: 100%;
    max-height: 100%;
    padding-top: 10vw;
    @media only screen and (min-width: 600px) {
      align-items: flex-start;
      justify-content: center;
      height: 51.5vw;
      max-height: 23.5rem;
      padding: 0;
    }
    @media only screen and (min-width: 1000px) {
      max-height: 41.5rem;
    } ;
  `,
  SocialMediaMobileIcon = styled.div`
  @media only screen and (max-width: 599px) {
    align-items:center;
    position:relative;
    right:50%;
    left:50%;
  }
  `,
  ButtonBox = styled.div`
    padding: 1rem 0vw;
    @media only screen and (min-width: 600px) {
      padding: 0.5vw 0vw;
    }
  `
  ;
